import React, { FC, ComponentProps } from "react";
import { cls } from "@wss/cls";

const Description: FC<ComponentProps<"span">> = ({
  className,
  children,
  ...rest
}) => (
  <span
    data-testid="topper-item-description"
    className={cls(
      "leading-3 line-clamp-3 mt-1 text-xs text-gray-800",
      className,
    )}
    {...rest}
  >
    {children}
  </span>
);

export default Description;
